module.exports = __webpack_public_path__ + "img/docs-nav.b978980e.png";